export default __webpack_public_path__ + "static/stanek-952e31a4fdf7c616bb7c28aa9601b66c.jpg";